import request from '@/modules/base/util/request'
import config from 'config'

const baseUrl = `${config.resourceHost}`

export const GenericListsService = {
  getCustomerAndSuppliersSsr: (options) => {
    const { startRow = 0, endRow = 20, searchTerm = '', filterModel } = options

    return new Promise((resolve, reject) => {
      const url = `${baseUrl}generic/lists/supplier-customer`
      const data = { startRow, endRow, searchTerm, filterModel }
      return request(url, { auth: true, isConcurrent: true, method: 'POST', data })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },
}
